import styled from 'styled-components';

const StyledContainer = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 30px;
	width: 100%;
	height: 100%;
	background: rgba(17, 19, 20, 0.95);
	transition: opacity 0.3s ease;
	opacity: 0;

	&.fade-enter {
		opacity: 0;
	}

	&.fade-enter-active,
	&.fade-enter-done,
	&.fade-exit {
		opacity: 1;
	}

	&.fade-exit-active {
		opacity: 0;
	}
`;

const StyedTopContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 20px;

	img {
		width: 30px;
		height: 30px;
		user-select: none;
		pointer-events: none;
	}
`;

export { StyedTopContainer, StyledContainer };
